module.exports = __webpack_public_path__ + "static/media/about-alt.920efea3.svg";